import React from 'react';
import {Tabs, Tab} from 'material-ui';

const ConfigurationTabs = ({activeTab, onChange}) => (
    <Tabs
        value={activeTab}
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
    >
        <Tab label="Reviews Allocation" />
    </Tabs>
);

export default ConfigurationTabs;


// WEBPACK FOOTER //
// ./src/containers/configuration/ConfigurationTabs.jsx